import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/home";
import Operate from "@/components/operate";
import Operateday from "@/components/operateday";
import Operatemonth from "@/components/operatemonth";
import Operateweek from "@/components/operateweek";
import Operatehuhui from "@/components/operatehuhui";
import Operateprotocol from "@/components/operateprotocol";
import Operatevip from "@/components/operatevip";
import News from "@/components/news"; //新闻中心
import Newsdetails from "@/components/newsdetails"; //新闻详情
import Help from "@/components/help"; //帮助中心
import StockMarket from "@/components/stockmarket"; //帮助中心
import Helpdetails from "@/components/helpdetails"; //帮助中心详情
import Login from "@/components/login"; //个人中心 登录页
import Register from "@/components/register"; //个人中心 注册
import Forgetpass from "@/components/forgetpass"; //找回密码
import Myaccount from "@/components/myaccount"; //个人中心
import Rechargeau from "@/components/rechargeau"; //充值中心 认证支付
import Strategynow from "@/components/strategynow"; //当前配资
import Entrust from "@/components/entrust"; //委托详情
import Strategyhistory from "@/components/strategyhistory"; //历史配资
import Strategyhistorydetails from "@/components/strategyhistorydetails"; //历史配资详情
import Protocol from "@/components/protocol"
import Information from "@/components/information"; //完善资料
import Usercoupon from "@/components/usercoupon"; //完善资料
import Detailed from "@/components/detailed"; //资金明细
import Helpabout from "@/components/helpabout"; //关于我们
import Helpguidelines from "@/components/helpguidelines"; //新手指引
import Helpguide from "@/components/helpguide"; //配资指南
import Helprules from "@/components/helprules"; //交易规则
import Helpagreement from "@/components/helpagreement"; //注册协议
import Helpqualification from "@/components/helpqualification"; //公司资质
import Helpoffice from "@/components/helpoffice"; //办公环境
import Helpcontact from "@/components/helpcontact"; //联系我们
import Helpapp from "@/components/helpapp"; //APP下载
import Helpcenter from "@/components/helpcenter"; //帮助中心
import Helpstatement from "@/components/helpstatement"; //法律声明
import Stockdetailed from "@/components/stockdetailed"   //股票细节
import Stockactivity from "@/components/stockactivity"   //活动专区
import Stockunactivity from "@/components/stockunactivity"   //活动结束
import Stockguild from "@/components/stockguild"   //活动专区
import Couponinfo from "@/components/couponinfo"
import Popupcontent from "@/components/popupcontent"
import Capital from "@/components/capital"   //活动专区
import Agency from "@/components/agency"   //活动专区
import Download from "@/components/download"   //活动专区
import tradingQuery from '@/components/tradingQuery'
import friendCoupon from '@/components/friendcoupon'
import riskControl from '@/components/riskControl'
import diagnosisStock  from '@/components/diagnosisStock'
import FinanceFund  from '@/components/FinanceFund'
import HolidayFund  from '@/components/HolidayFund'
import FoundWinners  from '@/components/FoundWinners'
import FoundWinnersDetails  from '@/components/FoundWinnersDetails'
import WinnersDiagnosis  from '@/components/WinnersDiagnosis'
import Popcontent1  from '@/components/popcontent1'
import timebao  from '@/components/Timebao'
import gxpay from '@/components/gxpay'

Vue.use(Router);

export default new Router({
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "Home",
      components: {
        main: Home
      }
    },
    {
      path: "/download",
      name: "Download",
      components: {
        main: Download
      }
    },
    {
      path: "/protocol/type=:type",
      name: "Protocol",
      components: {
        main: Protocol
      }
    },
    {
      path: "/operate",
      name: "Operate",
      components: {
        main: Operate
      },
      children: [
        {
          path: "/operate/operateday",
          name: "Operateday",
          components: {
            child: Operateday
          }
        },
        {
          path: "/operate/operatemonth",
          name: "Operatemonth",
          components: {
            child: Operatemonth
          }
        },
        {
          path: "/operate/operateweek",
          name: "Operateweek",
          components: {
            child: Operateweek
          }
        },
        {
          path: "/operate/operatehuhui",
          name: "Operatehuhui",
          components: {
            child: Operatehuhui
          }
        },
        {
          path: "/operate/protocol",
          name: "Operateprotocol",
          components: {
            child: Operateprotocol
          }
        },
        {
          path: "/operate/operatevip", //add by kasun, added for operateVip page
          name: "Operatevip",
          components: {
            child: Operatevip
          }
        }
      ],
      redirect: "/operate/operateday"
    },
    {
      path: "/news",
      name: "News",
      components: {
        main: News
      }
    },
    {
      path: "/diagnosis_stock",
      name: "diagnosisStock",
      components: {
        main: diagnosisStock
      }
    },
    {
      path: "/winners_diagnosis",
      name: "winners_diagnosis",
      components: {
        main: WinnersDiagnosis
      }
    },
    {
      path: "/found_winners",
      name: "FoundWinners",
      components: {
        main: FoundWinners
      }
    },
    {
      path: "/found_winners/details",
      name: "FoundWinnersDetails",
      components: {
        main: FoundWinnersDetails
      }
    },
    {
      path: "/news/newsdetails",
      name: "Newsdetails",
      components: {
        main: Newsdetails
      }
    },
    {
      path: "/help",
      name: "Help",
      components: {
        main: Help
      },
      children: [
        {
          path: "/help/helpabout", //关于我们
          name: 'Helpabout',
          component: Helpabout
        },
        {
          path: "/help/helpguidelines", //新手指引
          name: 'Helpguidelines',
          component: Helpguidelines
        },
        {
          path: "/help/helpguide", //配资指南
          name: 'Helpguide',
          component: Helpguide
        },
        {
          path: "/help/helprules", //交易规则
          name: 'Helprules',
          component: Helprules
        },
        {
          path: "/help/helpagreement", //注册协议
          name: 'Helpagreement',
          component: Helpagreement
        },
        {
          path: "/help/helpqualification", //公司资质
          name: 'Helpqualification',
          component: Helpqualification
        },
        {
          path: "/help/helpoffice", //办公环境
          name: 'Helpoffice',
          component: Helpoffice
        },
        {
          path: "/help/helpcontact", //联系我们
          name: 'Helpcontact',
          component: Helpcontact
        },
        {
          path: "/help/helpapp", //APP下载
          name: 'Helpapp',
          component: Helpapp
        },
        {
          path: "/help/helpcenter", //帮助中心
          name: 'Helpcenter',
          component: Helpcenter
        },
        {
          path: "/help/helpstatement", //法律声明
          name: 'Helpstatement',
          component: Helpstatement
        },
      ],
      redirect: "/help/helpabout"
    },
    {
      path: "/stockmarket",
      name: "StockMarket",
      components: {
        main: StockMarket
      },
    },
    {
      path: "/stockdetailed",
      name: "Stockdetailed",
      components: {
        main: Stockdetailed
      },
    },
    {
      path: "/popcontent1",
      name: "Popcontent1",
      components: {
        main: Popcontent1
      },
    },
    {
      path: "/stockactivity",
      name: "stockactivity",
      components: {
        main: Stockactivity
      },
    },
    {
      path: "/stockunactivity",
      name: "stockunactivity",
      components: {
        main: Stockunactivity
      },
    },
    {
      path: "/stockguild",
      name: "Stockguild",
      components: {
        main: Stockguild
      },
    },
    {
      path: "/couponinfo",
      name: "Couponinfo",
      components: {
        main: Couponinfo
      },
    },
    {
      path: "/popupcontent",
      name: "Popupcontent",
      components: {
        main: Popupcontent
      },
    },
    {
      path: "/help/helpdetails/id=:id",
      name: "Helpdetails",
      components: {
        main: Helpdetails
      }
    },
    {
      path: "/login",
      name: "Login",
      components: {
        main: Login
      }
    },
    {
      path: "/login/zhuce9999",
      name: "Register",
      components: {
        main: Register
      }
    },
    {
      path: "/register",
      redirect: "/login/zhuce9999"
    },
    {
      path: "/login/register",
      redirect: "/login/zhuce9999"
    },
    {
      path: "/login/forgetpass",
      name: "Forgetpass",
      components: {
        main: Forgetpass
      }
    },
    {
      path: "/myaccount",
      name: "Myaccount",
      components: {
        main: Myaccount
      },
      children: [
        {
          path: "/myaccount/rechange", //认证
          name: "Rechargeau",
          components: {
            kids: Rechargeau
          }
        },
        {
          path: "/myaccount/finance_fund", //定期宝
          name: "FinanceFund",
          components: {
            kids:FinanceFund
          }
        },
        {
          path: "/myaccount/holiday_fund", //节日宝
          name: "HolidayFund",
          components: {
            kids:HolidayFund
          }
        },
        {
          path: "/myaccount/strategynow", //提现记录
          name: "Strategynow",
          components: {
            kids: Strategynow
          }
        },
        {
          path: "/myaccount/risk_control", //提现记录
          name: "riskControl",
          components: {
            kids: riskControl
          }
        },
        {
          path: "/myaccount/gxpay", //提现记录
          name: "gxpay",
          components: {
            kids: gxpay
          }
        },

        {
          path: "/myaccount/entrust", //委托
          name: "Entrust",
          components: {
            kids: Entrust
          }
        },
        {
          path: "/myaccount/capital", //资金操作
          name: "capital",
          components: {
            kids: Capital
          }
        },
        {
          path: "/myaccount/agency",
          name: "Agency",
          components: {
            kids: Agency
          }
        },
        {
          path: "/myaccount/strategyhistory", //历史配资
          name: "Strategyhistory",
          components: {
            kids: Strategyhistory
          }
        },
        {
          path: "/myaccount/strategyhistorydetails", //历史配资详情
          name: "Strategyhistorydetails",
          components: {
            kids: Strategyhistorydetails
          }
        },
        {
          path: "/myaccount/information", //完善资料
          name: "Information",
          components: {
            kids: Information
          }
        },
        {
          path: "/myaccount/usercoupon", //完善资料
          name: "Usercoupon",
          components: {
            kids: Usercoupon
          }
        },
        {
          path: "/myaccount/detailed", //资金明细
          name: "Detailed",
          components: {
            kids: Detailed
          }
        },
        {
          path: "/myaccount/trading_query", //资金明细
          name: "tradingQuery",
          components: {
            kids: tradingQuery
          }
        },
        {
          path: "/myaccount/friend_coupon", //资金明细
          name: "friendCoupon",
          components: {
            kids: friendCoupon
          }
        },
        {
          path: "/myaccount/timebao",
          name: "timebao",
          components: {
            kids: timebao
          },
        },
      ],
      redirect: "/myaccount/rechange"
    },
    {
      path: '*',
      redirect: "/home"
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js